module.exports = __webpack_public_path__ + "static/media/logo.22283d6a.svg";